import React from 'react';
import { SvgIconProps } from '@mui/material';
import { ArrowRight } from './arrow-right';

export const ArrowBottom = (props: SvgIconProps) => (
  <ArrowRight
    {...props}
    sx={{ transform: 'rotate(90deg)', ...(props.sx || {}) }}
  />
);
